import _toConsumableArray from "/buddy/cc-maintainer-fe/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js";
/**
 * Store web sites list
 *
 * @param state
 * @param payload
 */

export function SET_WEB_SEARCH_LIST(state, payload) {
  state.webSitesList = payload;
}

/**
 * Add selected site
 *
 * @param state
 * @param siteUrl
 * @constructor
 */
export function SET_WEB_SELECTED_SITES(state, siteUrl) {
  if (state.webSelectedSites.some(function (url) {
    return url === siteUrl;
  })) {
    state.webSelectedSites.forEach(function (url, index) {
      if (url === siteUrl) {
        state.webSelectedSites.splice(index, 1);
      }
    });
  } else {
    state.webSelectedSites = [].concat(_toConsumableArray(state.webSelectedSites), [siteUrl]);
  }
}
/**
 * Clear all selected sites
 *
 * @param state
 * @constructor
 */
export function CLEAR_SELECTED_SITES(state) {
  state.webSelectedSites = [];
}